import { api } from "../../src/component/constent";

// ============================================================
// RAILWAY MASTER
// ============================================================

export const getRailways = () => {
    return api.get(`/entry/railways`);
};


// ============================================================
// CURRENT MONTH
// ============================================================

export const currentMonth = () => {
    return api.get(`/entry/current-month`);
};


// ============================================================
// IOH LIST
// ============================================================

export const getIOHList = (month, year) => {

    return api.get(`/entry/ioh/`, {
        params: {
            month,
            year
        }
    });

};


// ============================================================
// CREATE
// ============================================================

export const createIOH = (data) => {

    return api.post(`/entry/ioh/`, data);

};


// ============================================================
// UPDATE
// ============================================================

export const updateIOH = (srno, data) => {

    return api.put(`/entry/ioh/${srno}`, data);

};


// ============================================================
// DELETE
// ============================================================

export const deleteIOH = (srno, month, year) => {

    return api.delete(`/entry/ioh/${srno}`, {
        params: {
            month,
            year
        }
    });

};